module.exports = __webpack_public_path__ + "media/images/bsmart/icons/report_sufficiente-0fd2a65a60ef6134075b5362cf1adaff.svg";